import { useEffect } from 'react';

/** Título da aba do navegador por página (auditoria A6): "Membros · Lictor". */
export function usePageTitle(titulo: string | null | undefined) {
  useEffect(() => {
    document.title = titulo ? `${titulo} · Lictor` : 'Lictor';
  }, [titulo]);
}
